import {
  Button,
  Description,
  Error,
  Form,
  Header,
  Illustration,
  Input,
  ValidationStates,
  Dialog
} from '@opengov/component-library/dist';
import { IReport } from '@opengov/reporting-types';
import React, { useState } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

import { IReportLocale } from '../../common/locale';

import styles from './ChartAndDetailsReportDeletingDialog.scss';
import { useToastContext } from '../../../src/components/Toast/contexts/useToast.context';
import { ToastProps } from '../../../src/components/Toast/Toast';
export interface IReportDeletingModal {
  reportLocaleText: IReportLocale;
  report: IReport;
  onClose(): void;
  onDelete(Report: IReport, navigate: NavigateFunction, toggleToast?: (toastProps: ToastProps) => void): void;
  open: boolean;
}

export const ChartAndDetailsReportDeletingDialog = (props: IReportDeletingModal) => {
  const { toggleToast } = useToastContext();
  const [confirmation, setConfirmation] = useState('');
  const [validationStatus, setValidationStatus] = useState(ValidationStates.None);
  const navigate = useNavigate();

  const handleConfirmationChange = (confirmation: string) => {
    if (confirmation.trim().length > 0 && confirmation === props.reportLocaleText.delete.confirmString) {
      setConfirmation(confirmation);
      setValidationStatus(ValidationStates.Success);
    } else {
      setConfirmation(confirmation);
      setValidationStatus(ValidationStates.Error);
    }
  };

  const handleDelete = () => {
    props.onDelete(props.report, navigate, toggleToast);
  };

  const {
    reportLocaleText: {
      cancel,
      delete: { label, confirmString },
      reportExplorer: {
        delete: { title, body1, body2, confirmationLabel, helper }
      }
    }
  } = props;

  return (
    <Dialog.Destructive
      onClose={() => {
        props.onClose();
      }}
    >
      <div className={styles.borders}>
        <div>
          <Illustration illustration="destruction" />
        </div>
        <div>
          <Header variant="h2">{title}</Header>
          <div className={styles.body}>
            <Description>{body1}</Description>
            <div className={styles.descriptionDivider}>
              <Description>{body2}</Description>
            </div>
          </div>

          <div className={styles.input}>
            <Form.Item
              required={true}
              label={confirmationLabel({ confirm: confirmString })}
              htmlFor="deleteConfirmationInput"
            >
              <Input.Text.Default
                id="deleteConfirmationInput"
                onChange={handleConfirmationChange}
                value={confirmation}
                data-test="reportConfirmationInput"
                validationState={validationStatus}
              />
              {validationStatus === ValidationStates.Error && (
                <Error data-test="errorStateMessage">{helper({ confirm: confirmString })}</Error>
              )}
            </Form.Item>
          </div>

          <div className={styles.buttons}>
            <Button
              title={cancel}
              onClick={() => {
                props.onClose();
              }}
              data-test="cancelDeleteReport"
            >
              {cancel}
            </Button>

            <Button
              variant="destructive"
              onClick={handleDelete}
              disabled={validationStatus !== ValidationStates.Success}
              data-test="delete-report-confirmation-button"
            >
              {label}
            </Button>
          </div>
        </div>
      </div>
    </Dialog.Destructive>
  );
};
